module.exports = __webpack_public_path__ + "static/media/company.bb822ffd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/atoms/Icon/assets/company.svg
// module id = 577
// module chunks = 0